class EstampaSpotlight extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(
      this.querySelectorAll("[data-estampa-match]")
    );
    if (!this.panels.length) return;

    this.onDocChange = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest(".sec__main-product")) return;
      if (
        target.matches(
          'input[type="radio"], select, variant-input, variant-selects'
        ) ||
        target.closest("variant-input, variant-selects, .product-form")
      ) {
        this.scheduleSync();
      }
    };

    this.onPopState = () => this.scheduleSync();
    document.addEventListener("change", this.onDocChange, true);
    window.addEventListener("popstate", this.onPopState);

    const main = document.querySelector(".sec__main-product");
    if (main) {
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.observer.observe(main, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    this.sync();
  }

  disconnectedCallback() {
    document.removeEventListener("change", this.onDocChange, true);
    window.removeEventListener("popstate", this.onPopState);
    this.observer?.disconnect();
    if (this.raf) cancelAnimationFrame(this.raf);
  }

  scheduleSync() {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => this.sync());
  }

  getMatchContext() {
    const values = [];

    document
      .querySelectorAll(
        '.sec__main-product input[type="radio"]:checked, .sec__main-product select option:checked'
      )
      .forEach((el) => {
        const value = (el.value || el.textContent || "").trim();
        if (value) values.push(value);
      });

    const jsonEl = document.querySelector(
      ".sec__main-product .productVariantSelected"
    );
    if (jsonEl?.textContent) {
      try {
        const variant = JSON.parse(jsonEl.textContent);
        if (variant?.title) values.push(String(variant.title));
        if (Array.isArray(variant?.options)) {
          variant.options.forEach((opt) => {
            if (opt) values.push(String(opt));
          });
        }
        if (variant?.name) values.push(String(variant.name));
      } catch (e) {
        // ignore invalid json during section swaps
      }
    }

    const productTitle =
      document.querySelector(".sec__main-product .block-product__title .title")
        ?.textContent ||
      document.querySelector(".sec__main-product h1.title")?.textContent ||
      "";
    if (productTitle.trim()) values.push(productTitle.trim());

    return values.join(" ").toLowerCase();
  }

  sync() {
    const haystack = this.getMatchContext();
    let activePanel = null;

    this.panels.forEach((panel) => {
      const match = (panel.getAttribute("data-estampa-match") || "")
        .trim()
        .toLowerCase();
      const isMatch = match !== "" && haystack.includes(match);
      panel.classList.toggle("is-active", isMatch);
      if (isMatch) {
        panel.hidden = false;
        if (!activePanel) activePanel = panel;
        else {
          panel.hidden = true;
          panel.classList.remove("is-active");
        }
      } else {
        panel.hidden = true;
      }
    });

    if (!activePanel) {
      const fallback = this.panels.find(
        (panel) => !(panel.getAttribute("data-estampa-match") || "").trim()
      );
      if (fallback) {
        fallback.hidden = false;
        fallback.classList.add("is-active");
        activePanel = fallback;
      }
    }

    this.toggleAttribute("data-has-active", Boolean(activePanel));
  }
}

if (!customElements.get("estampa-spotlight")) {
  customElements.define("estampa-spotlight", EstampaSpotlight);
}
